export const GA_FILTER_CLEAR_ACTION = 'clear filter';
export const GA_FILTER_SORTING_ACTION = 'sorting';

export const GA_SEARCH_OPEN_ACTION = 'open';
export const GA_SEARCH_CLEAR_ACTION = 'clear';
export const GA_SEARCH_TAB_INTERACTION_ACTION = 'tab interaction';
export const GA_SEARCH_TAB_SUGGESTIONS_VISIBLE_ACTION = 'suggested result visible';
export const GA_SEARCH_VIA_KEYBOARD_ACTION = 'via keyboard';
export const GA_SEARCH_VIA_AUTOCOMPLETE_ACTION = 'via autocomplete';
export const GA_SEARCH_VIA_RECENT_SEARCHES_ACTION = 'via recent searches';
export const GA_SEARCH_SPELLCHECKED_SUGGESTED_VISIBLE_ACTION = 'spellchecked suggested result visible';
export const GA_SEARCH_SPELLCHECKED_SUGGESTED_CLICKED_ACTION = 'spellchecked suggested result clicked';

export const GA_STORE_POPUP_SEEN = 'Country popup seen';
export const GA_STORE_POPUP_CLICKED = 'Country popup clicked';

export const GA_MY_BOOZT_ACTIONS = {
    orderOptions: 'order options',
    orderCancel: 'cancel purchase',
    login: 'login',
    sign_up: 'sign_up'
};

export const GA_ONLINE_RETURN_ACTIONS = {
    selectReturnItem: 'select return item',
    selectReturnReason: 'select return reason',
    confirmReturn: 'confirm return',
    returnConfirmed: 'return confirmed',
    confirmedReturnReason: 'confirmed return reason',
    confirmedReturnItem: 'confirmed return item'
};

export const GA_BOOZTPAY_ACTIONS = {
    moveToAccount: 'move to account',
    accountOptions: 'account options',
    invoiceOptions: 'invoice options',
    postponeInvoicePopUp: 'postpone invoice pop up',
    paymentSuccessful: 'payment successful'
};

export const GA_FAVORITES_ACTIONS = {
    addToFavorite: 'add to favourites',
    removeFromFavorites: 'remove to favourites'
};
